import { AxiosResponse } from "axios";
import { api, apiPOS } from "../library/axios";
import { API_ROUTE } from "../const/apiRoute";
import { isNullOrUndefined } from "../_base/extension/StringExtension";
import { NotificationExtension } from "../_base/extension/NotificationExtension";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { TblTradeInProductEdit } from "../model/TblTradeIn";

export const createTradeInOrder = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.CREATE_TRADE_IN_ORDER,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Gửi đơn thu cũ - đổi mới thành công");
    } else if (response != null)
      NotificationExtension.Fails("Gửi đơn thu cũ - đổi mới thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyTradeInOrder = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.put(
      API_ROUTE.MODIFY_TRADE_IN_ORDER,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success(
        "Chỉnh sửa đơn thu cũ - đổi mới thành công"
      );
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa đơn thu cũ - đổi mới thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getListTradeInHeader = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.GET_LIST_TRADE_IN_HEADER + data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyTradeInHeader = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.MODIFY_TRADE_IN_HEADER,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa danh mục thành công");
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa danh mục thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createTradeInProduct = async (
  data: TblTradeInProductEdit
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.CREATE_TRADE_IN_PRODUCT,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Thêm sản phẩm vào nhóm thành công");
    } else if (response != null)
      NotificationExtension.Fails("Thêm sản phẩm vào nhóm thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyTradeInProduct = async (
  data: TblTradeInProductEdit
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.put(
      API_ROUTE.MODIFY_TRADE_IN_PRODUCT,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa sản phẩm trong nhóm thành công");
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa sản phẩm trong nhóm thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteTradeInProduct = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETES_TRADE_IN_PRODUCT,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xoá sản phẩm trong nhóm thành công");
    } else if (response != null)
      NotificationExtension.Fails("Xoá sản phẩm trong nhóm thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyTradeInProductActive = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.MODIFY_TRADE_IN_PRODUCT_ACTIVE,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getListCategoryTradeIn = async (data: {
  keySearch?: string;
  skip: number;
  take: number;
  status?: string;
}): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      "/TblCategoryForTradeIn/get-list",
      {
        params: {
          KeySearch: data.keySearch,
          Skip: data.skip,
          Take: data.take,
          Status: data.status,
        },
      }
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createCategoryTradeInSetting = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      "/TblCategoryForTradeIn/create-setting",
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Thêm mới cấu hình ngành hàng thành công");
    } else if (response != null)
      NotificationExtension.Fails(response?.data?.message || "Thêm mới cấu hình ngành hàng thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const editCategoryTradeInSetting = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      "/TblCategoryForTradeIn/edit-setting",
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật cấu hình ngành hàng thành công");
    } else if (response != null)
      NotificationExtension.Fails(response?.data?.message || "Cập nhật cấu hình ngành hàng thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getCategoryTradeInSettingDetail = async (id: number | string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      "/TblCategoryForTradeIn/edit-setting",
      {
        params: {
          Id: id,
        },
      }
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteCategoryTradeInSetting = async (ids: (number | string)[]): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      "/TblCategoryForTradeIn/delete-setting",
      { ids }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xóa cấu hình ngành hàng thành công");
    } else if (response != null) {
      NotificationExtension.Fails(response?.data?.message || "Xóa cấu hình ngành hàng thất bại !");
    }
    return response.data;
  } catch (error: any) {
    const msg = error?.response?.data?.message || "Xóa cấu hình ngành hàng thất bại !";
    NotificationExtension.Fails(msg);
    throw error;
  }
};

export const getListTradeInOrder = async (data: {
  take: number;
  skip: number;
  keySearch?: string | null;
  type?: string | null;
  status?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
  orgId?: string | null;
  provinceId?: number | null;
}): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      "/TblTradeInOrder/get-list",
      {
        params: {
          Take: data.take,
          Skip: data.skip,
          KeySearch: data.keySearch || null,
          Type: data.type || null,
          Status: data.status || null,
          FromDate: data.fromDate || null,
          ToDate: data.toDate || null,
          OrgId: data.orgId || null,
          ProvinceId: data.provinceId || null,
        },
      }
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDetailTradeInOrder = async (id: number): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      "/TblTradeInOrder/get-detail",
      {
        params: {
          Id: id,
        },
      }
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getTradeInCrossList = async (data: {
  tradeUpSku: string;
  take?: number;
  skip?: number;
  keySearch?: string;
}): Promise<any> => {
  try {
    const response: AxiosResponse = await apiPOS.post(
      "/api-client/api/v1/TblTradeInProduct/get-trade-in-cross-list",
      data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

